import tokenKeeper from 'lib/apiTokenKeeper';

export const getAuthToken = (): Promise<string | undefined> => tokenKeeper.getToken();
